import BaseService from "../../services/BaseService";
import RecentUserTransactionCategoryService from "../../services/RecentUserTransactionCategoryService";

export default {
  state: {
    recentUserTransactionCategories: [],
    recentUserTransactionCategoriesLoaded: false,
  },
  getters: {
    recentUserTransactionCategories: (state) => {
      return state.recentUserTransactionCategories;
    },
    recentUserTransactionCategoriesLoaded: (state) => {
      return state.recentUserTransactionCategoriesLoaded;
    },
  },
  mutations: {
    SET_RECENT_USER_TRANSACTION_CATEGORIES(state, TransactionCategories) {
      state.recentUserTransactionCategories = TransactionCategories;
    },
    SET_RECENT_USER_TRANSACTION_CATEGORIES_LOADED(state) {
      state.recentUserTransactionCategoriesLoaded = true;
    },
  },
  actions: {
    async loadRecentUserTransactionCategories({ commit }) {
      let result = await RecentUserTransactionCategoryService.index();

      if (result.status === BaseService.STATUS_200) {
        commit("SET_RECENT_USER_TRANSACTION_CATEGORIES", result.data);
        commit("SET_RECENT_USER_TRANSACTION_CATEGORIES_LOADED");
      }
    },
  },
};
